import { render, staticRenderFns } from "./IconSparklesOutline.vue?vue&type=template&id=c5b0914c"
import script from "./IconSparklesOutline.vue?vue&type=script&lang=js"
export * from "./IconSparklesOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports